module.exports = __webpack_public_path__ + "static/video2-baa8e42f3380d8d59c42f5900bc93800.png";